import { BusMessage, MessageFactory } from "flavr-common";
export class MediaStreamAddedMessage extends BusMessage {
    get byteLength() {
        return MediaStreamAddedMessage.BYTE_LENGTH;
    }
    constructor(clientId, producerId, stream) {
        super();
        this.clientId = clientId;
        this.producerId = producerId;
        this.stream = stream;
    }
    serialization() { }
    static is(msg) {
        return msg.type === MediaStreamAddedMessage.typestatic;
    }
}
MediaStreamAddedMessage.typestatic = "MediaStreamAddedMessage";
MediaStreamAddedMessage.subjectstatic = "local";
MediaStreamAddedMessage.BYTE_LENGTH = 0;
MessageFactory.register(MediaStreamAddedMessage);
export class MediaStreamRemovedMessage extends BusMessage {
    get byteLength() {
        return MediaStreamRemovedMessage.BYTE_LENGTH;
    }
    constructor(clientId, stream) {
        super();
        this.clientId = clientId;
        this.stream = stream;
    }
    serialization() { }
    static is(msg) {
        return msg.type === MediaStreamRemovedMessage.typestatic;
    }
}
MediaStreamRemovedMessage.typestatic = "MediaStreamRemovedMessage";
MediaStreamRemovedMessage.subjectstatic = "local";
MediaStreamRemovedMessage.BYTE_LENGTH = 0;
MessageFactory.register(MediaStreamRemovedMessage);
export class AudioOutputChangedMessage extends BusMessage {
    get byteLength() {
        return AudioOutputChangedMessage.BYTE_LENGTH;
    }
    serialization() { }
    static is(msg) {
        return msg.type === AudioOutputChangedMessage.typestatic;
    }
}
AudioOutputChangedMessage.typestatic = "AudioOutputChangedMessage";
AudioOutputChangedMessage.subjectstatic = "local";
AudioOutputChangedMessage.BYTE_LENGTH = 0;
MessageFactory.register(AudioOutputChangedMessage);
